// React
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import store from '../../../store';

// Actions
import {
  acceptUserAgreementTerms,
  generateAAAaccessToken,
  generateDCSAccessToken,
  logout,
  handleAAASignupLogin,
  invalidateRefreshToken,
  handleDCSLoginSignup
} from '../../../actions/LoginAction';
import { createUserEntry } from '../../../actions/ProfileAction';
import * as Constants from '../../../actions/configuration';

// Components
import HeaderLogin from '../../BaseLayout/HeaderLogin';
import AgreementModal from '../../../components/Shared/Utils/Modal/AgreementModal';

// Utiles
import ConfirmModal from '../../Shared/Utils/Modal/ConfirmationModal';
import Loader from '../../Shared/Utils/Loader';
import { AuthCallbackNavigation, sellerApiRestrictedRoles } from '../../../utils';

// Data
import idConstants from '../../../data/idConstants';

// Css
import './style.scss';

export default function AuthCallback(props) {
  const dispatchRedux = useDispatch();

  const {
    loginReducer: { validToken, user, checkUserAgreement, tokenInvalidated } = {},
    CompanyDetailsReducer: {
      isRegistrationCheckDone,
      companyDetailsError,
      userCompanyStatus
    } = {},
    ProfileReducer: { userDeregistered } = {}
  } = useSelector((state) => state);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [confirmationModalLoader, setConfirmationModalLoader] = useState(false);
  const [showPrivacyPoliciesModal, setShowPrivacyPoliciesModal] = useState(false);
  const [privacyPoliciesPdfUrl, setPrivacyPoliciesPdfUrl] = useState('');
  const [privacyPoliciesAgreementMasterData, setPrivacyPoliciesAgreementMasterData] =
    useState('');
  const [isSwitchMessage, setIsSwitchMessage] = useState(false);
  const [createUserCall, setCreateUserCall] = useState(false);
  const adfsLogin = process.env.REACT_APP_SKID_STYLE_IDP_HINT_SALES;
  const reLoginWithAdfs = localStorage.getItem(idConstants.tokens.reLogin);
  const rolesWithoutSellerApi = sellerApiRestrictedRoles(user?.roles);

  const getAAAAuthCode = () => {
    const callbackParams = new URLSearchParams(props.location.search);
    localStorage.setItem(idConstants.tokens.aaaCode, callbackParams.get('code'));
    if (callbackParams.get(idConstants.tokens.aaaVerifier)) {
      localStorage.setItem(
        idConstants.tokens.aaaVerifier,
        callbackParams.get(idConstants.tokens.aaaVerifier)
      );
    }
    dispatchRedux(generateAAAaccessToken(callbackParams.get('code')));
    if (Constants.SYSTEM_ACCOUNT_AUTH_TOGGLE === 'false') handleDCSLoginSignup();
    else setCreateUserCall(true);
  };

  const getDCSAuthCode = () => {
    const callbackParams = new URLSearchParams(props.location.search);
    localStorage.setItem(idConstants.tokens.dcsCode, callbackParams.get('code'));
    dispatchRedux(generateDCSAccessToken(callbackParams.get('code')));
    setCreateUserCall(true);
  };

  useEffect(() => {
    if (store.getState().loginReducer.countryCodeFlagSet && createUserCall) {
      setCreateUserCall(false);
      dispatchRedux(createUserEntry(rolesWithoutSellerApi));
    }
  }, [store.getState().loginReducer.countryCodeFlagSet]);

  const dependencyArrayCheckAgreement = [
    validToken,
    isRegistrationCheckDone,
    companyDetailsError,
    checkUserAgreement,
    userCompanyStatus,
    rolesWithoutSellerApi
  ];
  if (Constants.SYSTEM_ACCOUNT_AUTH_TOGGLE === 'false')
    dependencyArrayCheckAgreement.push(
      localStorage.getItem(idConstants.tokens.dcsJwtToken)
    );

  useEffect(() => {
    const toggledIf =
      Constants.SYSTEM_ACCOUNT_AUTH_TOGGLE === 'false'
        ? validToken &&
          checkUserAgreement &&
          localStorage.getItem(idConstants.tokens.dcsJwtToken)
        : validToken && checkUserAgreement;

    if (
      toggledIf &&
      (rolesWithoutSellerApi?.length > 0 || (isRegistrationCheckDone || companyDetailsError) &&
      (!userCompanyStatus?.areCompanyDetailsCaptured ||
        (userCompanyStatus?.areCompanyDetailsCaptured &&
          (!checkUserAgreement.some(
            (userAgreement) =>
              idConstants.documentTypeIds.privacyPolicy ===
              userAgreement.documentTypeId
          ) ||
            checkUserAgreement.some(
              (userAgreement) =>
                idConstants.documentTypeIds.privacyPolicy ===
                  userAgreement.documentTypeId && userAgreement.accepted
            )))))
    ) {
      AuthCallbackNavigation(props, user?.roles);
    }
  }, dependencyArrayCheckAgreement);

  const dependencyArrayUserCompanyStatus = [
    validToken,
    userCompanyStatus,
    checkUserAgreement
  ];
  if (Constants.SYSTEM_ACCOUNT_AUTH_TOGGLE === 'false')
    dependencyArrayUserCompanyStatus.push(
      localStorage.getItem(idConstants.tokens.dcsJwtToken)
    );

  useEffect(() => {
    const toggledIf =
      Constants.SYSTEM_ACCOUNT_AUTH_TOGGLE === 'false'
        ? validToken &&
          localStorage.getItem(idConstants.tokens.dcsJwtToken) &&
          userCompanyStatus?.areCompanyDetailsCaptured &&
          checkUserAgreement
        : validToken &&
          userCompanyStatus?.areCompanyDetailsCaptured &&
          checkUserAgreement;
    if (toggledIf) {
      const privacyPolicy = checkUserAgreement.find(
        (userAgreement) =>
          idConstants.documentTypeIds.privacyPolicy === userAgreement.documentTypeId
      );
      if (privacyPolicy && !privacyPolicy.accepted) {
        setShowPrivacyPoliciesModal(true);
        setPrivacyPoliciesPdfUrl(
          `${process.env.REACT_APP_STAAS_CDN_URL}${privacyPolicy.blobFileUrl?.substring(privacyPolicy.blobFileUrl?.indexOf('/') + 1)}`
        );
        setPrivacyPoliciesAgreementMasterData(privacyPolicy);
      }
    }
  }, dependencyArrayUserCompanyStatus);

  useEffect(() => {
    if (tokenInvalidated) {
      if (reLoginWithAdfs) {
        handleAAASignupLogin(adfsLogin);
      } else {
        props.history.push('/login');
        dispatchRedux({
          type: 'TOKEN_INVALIDATED',
          payload: false
        });
      }
    }
  }, [tokenInvalidated]);

  useEffect(() => {
    if (userDeregistered?.error === idConstants.errorCodes.deregError) {
      setOpenConfirmModal(true);
    }
  }, [userDeregistered]);

  useEffect(() => {
    if (
      window.location.pathname.split('/')[1] ===
      Constants.CALLBACK_PARAM.AAA_CALLBACK
    ) {
      getAAAAuthCode();
    }
  }, []);

  useEffect(() => {
    if (
      Constants.SYSTEM_ACCOUNT_AUTH_TOGGLE === 'false' &&
      window.location.pathname.split('/')[1] ===
        Constants.CALLBACK_PARAM.DCS_CALLBACK
    ) {
      getDCSAuthCode();
    }
  }, []);

  useEffect(() => {
    if (
      window.location.pathname.split('/')[1] ===
      Constants.CALLBACK_PARAM.SWITCH_CALLBACK
    ) {
      setIsSwitchMessage(true);
      handleAAASignupLogin();
    }
  }, []);

  useEffect(() => {
    if (
      window.location.pathname.split('/')[1] ===
      Constants.CALLBACK_PARAM.DEREGISTRATION_CALLBACK
    ) {
      window.location.href = process.env.REACT_APP_SKID_DELETE;
    }
  }, []);

  useEffect(() => {
    if (
      window.location.pathname.split('/')[1] ===
      Constants.CALLBACK_PARAM.FEDERATED_CALLBACK
    ) {
      dispatchRedux(invalidateRefreshToken());
    }
  }, []);

  const handleAgreePrivacyPolicies = () => {
    const privacyDTO = {};
    const privacyPolicy = [];
    privacyDTO.docMetaInfoId = privacyPoliciesAgreementMasterData.docMetaInfoId;
    privacyDTO.documentTypeId = privacyPoliciesAgreementMasterData.documentTypeId;
    privacyDTO.userConsentNeeded =
      privacyPoliciesAgreementMasterData.userConsentNeeded;
    privacyDTO.accepted = true;
    privacyPolicy.push(privacyDTO);
    dispatchRedux(acceptUserAgreementTerms(privacyPolicy));
  };

  const handleDeclineAgreements = () => {
    dispatchRedux(logout());
    setShowPrivacyPoliciesModal(false);
  };

  const handleLogOutUser = () => {
    setOpenConfirmModal(false);
    setConfirmationModalLoader(true);
    dispatchRedux(logout());
  };

  return (
    <div className='redirect-message'>
      <HeaderLogin />
      <span className='redirect-message-span'>
        {isSwitchMessage
          ? 'Please Wait while we switch you to the SELLER Marketplace !'
          : 'Redirecting, please wait...'}
      </span>
      {showPrivacyPoliciesModal && (
        <AgreementModal
          title='Privacy Policy'
          actionRequired={true}
          okAction={handleAgreePrivacyPolicies}
          closeAction={handleDeclineAgreements}
          pdfUrl={privacyPoliciesPdfUrl}
        />
      )}
      {confirmationModalLoader && <Loader />}
      {openConfirmModal && (
        <ConfirmModal
          modalContent=''
          heading={userDeregistered?.message}
          category={'approve'}
          callback={handleLogOutUser}
          okBtnAction={handleLogOutUser}
          cancelBtn='disable'
          noCloseIcon
          {...props}
        />
      )}
    </div>
  );
}
